import { render, staticRenderFns } from "./configPrivateLetter.vue?vue&type=template&id=622867c5&"
import script from "./configPrivateLetter.vue?vue&type=script&lang=js&"
export * from "./configPrivateLetter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports